import React from 'react'
import Footer from './finwhale/footer'
import Nav from './finwhale/nav'
import Search from './finwhale/search'
import _ from 'lodash'
import PriceListRequest from './finwhale/common/price-list-request/inline'
import FinwhaleMap from './finwhale/common/fw-map'
import Meta from 'src/basic/Meta';
import GoogleAnalytics from './Analytics'
import CurrentLanguageContext from 'src/context/currentLanguageContext';


function BasePage (props) {
  return (
    <CurrentLanguageContext.Consumer>
      {currentLanguage => {
        return (
          <div
            style={{
              margin: 'auto',
              position: 'relative',
            }}
          >
            <Meta title="Finwhale" />
            <Nav/>
            {currentLanguage !== 'en' && <Search location={_.get(props, 'location.pathname')}/>}
            {props.children}
            <FinwhaleMap
              style={{
                marginTop: 40,
              }}
            />
            <PriceListRequest currentLanguage={currentLanguage}/>
            <Footer/>
          </div>
        );
      }}
    </CurrentLanguageContext.Consumer>
  );
}

export default GoogleAnalytics(BasePage)



// WEBPACK FOOTER //
// ./src/BasePage.js